import {Listbox} from "@headlessui/react";
import React, {Fragment} from "react";
import {DropdownButtonSubMenuItem} from "./DropdownButton";
import Button from "./Button";
import IconArrowDown from "../../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";
import {Float} from "@headlessui-float/react";
import {useTranslation} from "next-i18next";

interface FormDropdownProps {
	menuItems: DropdownButtonSubMenuItem[];
	text: string;
	onSelectedItem: (subMenuItem: DropdownButtonSubMenuItem) => void;
}

function FormDropdown({menuItems, onSelectedItem, text}: FormDropdownProps) {
	const {t} = useTranslation();
	return (
		<Listbox
			value={menuItems[0]}
			onChange={onSelectedItem}
			as={"div"}
			className={"w-full h-[40px] relative"}
		>
			<Float floatingAs={Fragment} flip>
				<Listbox.Button className={"w-full h-full"}>
					{({open}) => (
						<div className="flex w-full flex-row items-center px-5 justify-between">
							<p>{text}</p>
							<div className={`w-3 h-3 ${open && "rotate-180"}`}>
								<IconArrowDown/>
							</div>
						</div>
					)}
				</Listbox.Button>
				<Listbox.Options
					className={"flex flex-col items-start w-full drop-shadow-lg z-40"}
				>
					{menuItems.map((item) => (
						<Listbox.Option key={item.name} value={item} className={"w-full"}>
							{({active}) => (
								<Button
									// className={`${active && "bg-blue-500"}`}
									onClick={item.onClick}
									text={t(item.name)}
									transparent={false}
									border={false}
									bgColor="bg-white"
									height="h-10"
									textAlign="text-left"
									minWidth="w-full"
									type="button"
									endAdornmentSpaceBetween
								/>
							)}
						</Listbox.Option>
					))}
				</Listbox.Options>
			</Float>
		</Listbox>
	);
}

export default FormDropdown;
